<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <learningDepartment-details ref="learningDepartmentDetails"
                       v-bind:learningDepartment="learningDepartment" />
    </v-card>
  </div>
</template>

<script>
  import LearningDepartmentDetails from '@/components/learning/LearningDepartmentDetails'

  export default {
    components: {
      LearningDepartmentDetails
    },
    name: 'LearningDepartmentDetailsCard',
    methods: {
      validate() {
        return this.$refs.learningDepartmentDetails.validate()
      }
    },
    props: {
      learningDepartment: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>